import { Route } from 'react-router';

import { SecuritySwitch } from '@dreryk/egabinet-security-frontend';

import { protectFeature } from '~libs.shared.system';
import { patientPaths } from '~libs.desktop.shared.paths';

import { CreatePatientPanel } from './CreatePatientPanel/CreatePatientPanel';
import { PatientDependencies, PatientDependenciesContextProvider } from './dependencies';
import { PatientConfirmedUpdatePanel } from './PatientConfirmedUpdatePanel/PatientConfirmedUpdatePanel';
import { PatientListPanel } from './PatientListPanel/PatientListPanel';
import { PatientUnconfirmedUpdatePanel } from './PatientUnconfirmedUpdatePanel/PatientUnconfirmedUpdatePanel';

export type PatientModuleRouterProps = PatientDependencies;

export const usePatientModuleRouter = (props: PatientModuleRouterProps): JSX.Element | null => {
   return protectFeature(
      'creatingPatients',
      <Route
         path={[
            patientPaths.LIST_PATIENTS_PATH,
            patientPaths.PATIENT_CREATE_PATH,
            patientPaths.TEMPORARY_PATIENT_PATH,
            patientPaths.PATIENT_DATA_PATH,
         ]}
      >
         <PatientDependenciesContextProvider
            accountConfigurationVerificationEventInterceptor={props.accountConfigurationVerificationEventInterceptor}
            appointmentOutOfScheduleButton={props.appointmentOutOfScheduleButton}
            visitHistoryPanel={props.visitHistoryPanel}
            visitsHistoryButton={props.visitsHistoryButton}
            showVisitButton={props.showVisitButton}
         >
            <SecuritySwitch>
               <Route path={patientPaths.LIST_PATIENTS_PATH} exact>
                  <PatientListPanel />
               </Route>
               <Route path={patientPaths.PATIENT_CREATE_PATH}>
                  <CreatePatientPanel />
               </Route>
               <Route path={patientPaths.TEMPORARY_PATIENT_PATH}>
                  <PatientUnconfirmedUpdatePanel />
               </Route>
               <Route path={patientPaths.PATIENT_DATA_PATH}>
                  <PatientConfirmedUpdatePanel />
               </Route>
            </SecuritySwitch>
         </PatientDependenciesContextProvider>
      </Route>,
      null
   );
};
